import CryptoES from "crypto-es";

export const encrypt = (str, k) => {
  var KEY = k ? k : process.env.REACT_APP_LOCALSTORAGE_KEY; //32位
  var IV = process.env.REACT_APP_LOCALSTORAGE_IV; //16位
  var key = CryptoES.enc.Utf8.parse(KEY);
  var iv = CryptoES.enc.Utf8.parse(IV);

  var encrypted = "";

  var srcs = CryptoES.enc.Utf8.parse(str);
  encrypted = CryptoES.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoES.mode.CBC,
    padding: CryptoES.pad.Pkcs7,
  });

  return encrypted.ciphertext.toString();
};
export const decrypt = (str, k) => {
  var KEY = k ? k : process.env.REACT_APP_LOCALSTORAGE_KEY; //32位
  var IV = process.env.REACT_APP_LOCALSTORAGE_IV; //16位
  var key = CryptoES.enc.Utf8.parse(KEY);
  var iv = CryptoES.enc.Utf8.parse(IV);
  var encryptedHexStr = CryptoES.enc.Hex.parse(str);
  var srcs = CryptoES.enc.Base64.stringify(encryptedHexStr);
  var decrypt = CryptoES.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoES.mode.CBC,
    padding: CryptoES.pad.Pkcs7,
  });
  var decryptedStr = decrypt.toString(CryptoES.enc.Utf8);
  return decryptedStr.toString();
};
// export const createGuid = () => {
//   return Crypto.randomUUID();
// };
export const createGuid = () => {
  return crypto.randomUUID();
};
